import { WithLoading } from "@vividtheory/minerva-legacy";
import React, { useState } from "react";
import { Button, FlexScrollArea, FlexScrollAreaContainer, Grid, Stack, Typography, } from "../components";
export const ExitIntentModal = ({ discard, save, loading: l = false, withLoading = true, subtitle = "You have unsaved changes, save or discard them to leave this screen.", buttons: b, sx, }) => {
    var _a, _b;
    const [loading, setLoading] = useState(l);
    const buttons = {
        text1: (_a = b === null || b === void 0 ? void 0 : b.text1) !== null && _a !== void 0 ? _a : "Discard",
        text2: (_b = b === null || b === void 0 ? void 0 : b.text2) !== null && _b !== void 0 ? _b : "Save & Exit",
    };
    return (React.createElement(FlexScrollAreaContainer, { height: "100%" },
        React.createElement(FlexScrollArea, { sx: Object.assign({ flexDirection: "column", padding: 4, minHeight: (theme) => theme.spacing(26) }, sx), gap: 4 },
            React.createElement(Stack, { gap: 1 },
                React.createElement(Typography, { variant: "h6", fontWeight: "bold" }, "Hold On \u270B"),
                React.createElement(Typography, { variant: "body2", sx: {
                        color: (theme) => theme.palette.disabled.onContainer,
                    } }, subtitle))),
        React.createElement(Stack, { gap: 4, sx: {
                padding: 4,
            } },
            React.createElement(Grid, { container: true, spacing: 4 },
                React.createElement(Grid, { item: true, xs: 6 },
                    React.createElement(Button, { variant: "outlined", fullWidth: true, onClick: discard }, buttons.text1)),
                React.createElement(Grid, { item: true, xs: 6 }, withLoading ? (React.createElement(WithLoading, { loading: loading, text: "Saving..." },
                    React.createElement(Button, { fullWidth: true, onClick: () => {
                            setLoading(true);
                            save();
                        } }, buttons.text2))) : (React.createElement(Button, { fullWidth: true, onClick: save }, buttons.text2)))))));
};
//# sourceMappingURL=ExitIntentModal.js.map